(function () {
  var CM_SEARCH_URL = "https://oewholesale1.myconvermax.com/search.json";

  var CART_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">' +
    '<path d="M0 0.771429C0 0.566833 0.0812809 0.370617 0.225962 0.225946C0.370643 0.0812752 0.566873 0 0.771482 0H1.34547C2.32268 0 2.909 0.657257 3.24331 1.26823C3.46653 1.67554 3.62802 2.14766 3.75455 2.57554L3.85741 2.57143H16.7134C17.5672 2.57143 18.1844 3.38811 17.9498 4.20994L16.0695 10.8021C15.9009 11.3933 15.5442 11.9136 15.0535 12.284C14.5627 12.6545 13.9646 12.8549 13.3497 12.8551H7.23136C6.6116 12.8551 6.00898 12.6516 5.51613 12.2759C5.02327 11.9001 4.66747 11.3729 4.5034 10.7753L3.72163 7.92412L2.42554 3.55474L2.42451 3.54651C2.26404 2.96331 2.11386 2.41714 1.88962 2.00983C1.67463 1.61383 1.50182 1.54286 1.34649 1.54286H0.771482C0.566873 1.54286 0.370643 1.46158 0.225962 1.31691C0.0812809 1.17224 0 0.976024 0 0.771429ZM5.21831 7.54972L5.99082 10.367C6.14512 10.9245 6.65224 11.3122 7.23136 11.3122H13.3497C13.6292 11.3122 13.9011 11.2212 14.1242 11.0528C14.3473 10.8845 14.5095 10.6481 14.5862 10.3793L16.3729 4.11429H4.20201L5.20391 7.4952L5.21831 7.54972ZM8.74347 15.9429C8.74347 16.4884 8.52672 17.0117 8.1409 17.3975C7.75509 17.7833 7.23181 18 6.68618 18C6.14055 18 5.61728 17.7833 5.23146 17.3975C4.84564 17.0117 4.62889 16.4884 4.62889 15.9429C4.62889 15.3973 4.84564 14.874 5.23146 14.4882C5.61728 14.1024 6.14055 13.8857 6.68618 13.8857C7.23181 13.8857 7.75509 14.1024 8.1409 14.4882C8.52672 14.874 8.74347 15.3973 8.74347 15.9429ZM7.2005 15.9429C7.2005 15.8065 7.14632 15.6756 7.04986 15.5792C6.95341 15.4828 6.82259 15.4286 6.68618 15.4286C6.54977 15.4286 6.41895 15.4828 6.3225 15.5792C6.22605 15.6756 6.17186 15.8065 6.17186 15.9429C6.17186 16.0793 6.22605 16.2101 6.3225 16.3065C6.41895 16.403 6.54977 16.4571 6.68618 16.4571C6.82259 16.4571 6.95341 16.403 7.04986 16.3065C7.14632 16.2101 7.2005 16.0793 7.2005 15.9429ZM15.944 15.9429C15.944 16.4884 15.7272 17.0117 15.3414 17.3975C14.9556 17.7833 14.4323 18 13.8867 18C13.3411 18 12.8178 17.7833 12.432 17.3975C12.0461 17.0117 11.8294 16.4884 11.8294 15.9429C11.8294 15.3973 12.0461 14.874 12.432 14.4882C12.8178 14.1024 13.3411 13.8857 13.8867 13.8857C14.4323 13.8857 14.9556 14.1024 15.3414 14.4882C15.7272 14.874 15.944 15.3973 15.944 15.9429ZM14.401 15.9429C14.401 15.8065 14.3468 15.6756 14.2504 15.5792C14.1539 15.4828 14.0231 15.4286 13.8867 15.4286C13.7503 15.4286 13.6195 15.4828 13.523 15.5792C13.4265 15.6756 13.3724 15.8065 13.3724 15.9429C13.3724 16.0793 13.4265 16.2101 13.523 16.3065C13.6195 16.403 13.7503 16.4571 13.8867 16.4571C14.0231 16.4571 14.1539 16.403 14.2504 16.3065C14.3468 16.2101 14.401 16.0793 14.401 15.9429Z" fill="currentColor"/>' +
    "</svg>";

  var DEALER_LOGIN_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" class="icon icon-dealer-login">' +
    '<path d="M10.8333 17.5C10.5972 17.5 10.3994 17.42 10.24 17.26C10.0806 17.1 10.0006 16.9022 10 16.6667C9.99945 16.4311 10.0794 16.2333 10.24 16.0733C10.4006 15.9133 10.5983 15.8333 10.8333 15.8333H15.8333V4.16667H10.8333C10.5972 4.16667 10.3994 4.08667 10.24 3.92667C10.0806 3.76667 10.0006 3.56889 10 3.33333C9.99945 3.09778 10.0794 2.9 10.24 2.74C10.4006 2.58 10.5983 2.5 10.8333 2.5H15.8333C16.2917 2.5 16.6842 2.66333 17.0108 2.99C17.3375 3.31667 17.5006 3.70889 17.5 4.16667V15.8333C17.5 16.2917 17.3369 16.6842 17.0108 17.0108C16.6847 17.3375 16.2922 17.5006 15.8333 17.5H10.8333ZM9.3125 10.8333H3.33334C3.09723 10.8333 2.89945 10.7533 2.74 10.5933C2.58056 10.4333 2.50056 10.2356 2.5 10C2.49945 9.76444 2.57945 9.56667 2.74 9.40667C2.90056 9.24667 3.09834 9.16667 3.33334 9.16667H9.3125L7.75 7.60417C7.59723 7.45139 7.52084 7.26389 7.52084 7.04167C7.52084 6.81944 7.59723 6.625 7.75 6.45833C7.90278 6.29167 8.09722 6.20472 8.33334 6.1975C8.56945 6.19028 8.77084 6.27028 8.9375 6.4375L11.9167 9.41667C12.0833 9.58333 12.1667 9.77778 12.1667 10C12.1667 10.2222 12.0833 10.4167 11.9167 10.5833L8.9375 13.5625C8.77084 13.7292 8.57306 13.8092 8.34417 13.8025C8.11528 13.7958 7.91722 13.7089 7.75 13.5417C7.59723 13.375 7.52445 13.1772 7.53167 12.9483C7.53889 12.7194 7.61861 12.5283 7.77084 12.375L9.3125 10.8333Z" fill="white"/>' +
    "</svg>";

  var moneyFormatter = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" });

  function formatMoney(amount) {
    return moneyFormatter.format(amount);
  }

  function isCustomerLoggedIn() {
    return document.body.classList.contains("customer-logged-in");
  }

  function buildStyleFacetUrl(style) {
    var url = new URL(CM_SEARCH_URL);
    url.searchParams.set("facet.0.field", "oew_style");
    url.searchParams.set("facet.0.selection", style);
    url.searchParams.set("pagesize", "25");
    return url.toString();
  }

  function fetchClassifierData(handle) {
    return fetch("/products/" + handle + "?view=classifier")
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return {
          finish: (data && data.specs && data.specs.finish) || "",
          upc: (data && data.barcode) || "",
        };
      })
      .catch(function () {
        return { finish: "", upc: "" };
      });
  }

  function addToCart(variantId, quantity, button) {
    if (!window.routes || !window.fetchConfig || !window.miniCart) {
      window.location = "/cart/add?id=" + variantId + "&quantity=" + quantity;
      return;
    }

    button.disabled = true;

    var config = window.fetchConfig("javascript");
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    config.body = JSON.stringify({
      id: variantId,
      quantity: quantity,
      sections: window.miniCart.getSectionsToRender().map(function (section) {
        return section.section;
      }),
      sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_add_url, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          window.miniCart.updateSectionContents();
          return;
        }

        window.miniCart.renderContents(response);
        window.miniCart.open(button);
      })
      .catch(function () {})
      .finally(function () {
        button.disabled = false;
      });
  }

  function buildCard(item, finishLabel, upc) {
    var card = document.createElement("div");
    card.className = "finish-options-item";

    var variantId = item.variant_ids && item.variant_ids[0];

    var metaHtml = "";
    if (item.sku) metaHtml += '<p class="finish-options-item-meta">' + item.sku + " &middot;</p>";
    if (upc) metaHtml += '<p class="finish-options-item-meta">UPC ' + upc + "</p>";
    metaHtml = metaHtml ? '<div class="finish-options-item-meta-wrap">' + metaHtml + "</div>" : "";

    var actionsHtml = isCustomerLoggedIn()
      ? '<div class="finish-options-item-actions">' +
        '<div class="finish-options-item-qty">' +
        '<button type="button" class="finish-options-qty-btn" data-qty-minus aria-label="Decrease quantity">&minus;</button>' +
        '<input type="number" class="finish-options-qty-input" value="1" min="1" aria-label="Quantity">' +
        '<button type="button" class="finish-options-qty-btn" data-qty-plus aria-label="Increase quantity">&plus;</button>' +
        "</div>" +
        '<button type="button" class="finish-options-item-cart" aria-label="Add to cart">' +
        CART_ICON_SVG +
        "</button>" +
        "</div>"
      : '<div class="finish-options-item-actions">' +
        '<a href="' +
        (document.body.dataset.accountLoginUrl || "/account/login") +
        '" class="button card-dealer-login-button">' +
        DEALER_LOGIN_ICON_SVG +
        "Login For Dealer Pricing" +
        "</a>" +
        "</div>";

    card.innerHTML =
      '<a href="' +
      item.url +
      '" class="finish-options-item-media">' +
      '<img src="' +
      item.image +
      '" alt="' +
      (finishLabel || item.title) +
      '" loading="lazy">' +
      "</a>" +
      '<a href="' +
      item.url +
      '" class="finish-options-item-title">' +
      (finishLabel || item.title) +
      "</a>" +
      metaHtml +
      (isCustomerLoggedIn()
        ? '<div class="finish-options-item-price">' +
          '<span class="finish-options-item-price-current">' +
          formatMoney(item.price) +
          "</span>" +
          "</div>"
        : "") +
      actionsHtml;

    if (isCustomerLoggedIn()) {
      var input = card.querySelector(".finish-options-qty-input");
      card.querySelector("[data-qty-minus]").addEventListener("click", function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });
      card.querySelector("[data-qty-plus]").addEventListener("click", function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });

      var cartButton = card.querySelector(".finish-options-item-cart");
      if (variantId) {
        cartButton.addEventListener("click", function () {
          addToCart(variantId, parseInt(input.value, 10) || 1, cartButton);
        });
      } else {
        cartButton.disabled = true;
      }
    }

    return card;
  }

  function initCarouselArrows(wrap) {
    var track = wrap.querySelector("[data-finish-options-track]");
    var prev = wrap.querySelector(".finish-options-arrow-prev");
    var next = wrap.querySelector(".finish-options-arrow-next");

    function scrollByCard(direction) {
      var card = track.querySelector(".finish-options-item");
      var amount = card ? card.getBoundingClientRect().width + 16 : 200;
      track.scrollBy({ left: amount * direction, behavior: "smooth" });
    }

    if (prev) prev.addEventListener("click", function () { scrollByCard(-1); });
    if (next) next.addEventListener("click", function () { scrollByCard(1); });
  }

  function initFinishOptions(wrap) {
    if (wrap.hasAttribute("data-cm-finish-options-initialized")) return;
    wrap.setAttribute("data-cm-finish-options-initialized", "1");

    var productId = wrap.dataset.productId;
    var style = wrap.dataset.productStyle;
    var track = wrap.querySelector("[data-finish-options-track]");
    if (!productId || !style || !track) return;

    initCarouselArrows(wrap);

    fetch(buildStyleFacetUrl(style))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var items = (data.Items || []).filter(function (item) {
          return String(item.id) !== String(productId);
        });

        if (!items.length) return;

        Promise.all(
          items.map(function (item) {
            return fetchClassifierData(item.handle).then(function (classifierData) {
              return buildCard(item, classifierData.finish, classifierData.upc);
            });
          })
        ).then(function (cards) {
          cards.forEach(function (card) {
            track.appendChild(card);
          });

          if (cards.length < 4) {
            wrap.querySelectorAll(".finish-options-arrow").forEach(function (arrow) {
              arrow.hidden = true;
            });
          }

          wrap.hidden = false;
        });
      })
      .catch(function () {});
  }

  function init() {
    document.querySelectorAll(".finish-options[data-product-style]").forEach(initFinishOptions);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
